export default "__VITE_ASSET__b3a8730f__"